<template>
  <v-container fluid class="mx-3">
    <v-row class="px-4 mt-4">
      <v-btn color="primary" @click="goBack()" depressed>
        <v-icon> mdi-chevron-left </v-icon>
      </v-btn>
      <div class="text-h4 pl-4">{{ $t("showSubstance.goBack.back") }}</div>
    </v-row>
    <v-row>
      <v-col cols="11" lg="10" xl="9">
        <table-export></table-export>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import TableExport from "../components/TableExport.vue";

export default {
  data() {
    return {
      TableExportdata: [],
      substance: [],
      headers: [],
    };
  },
  computed: {
    ...mapGetters(["lastPage"]),
  },
  components: {
    TableExport,
  },
  methods: {
    ...mapMutations(["setLastPage"]),
    goBack() {
      this.$router.push(this.lastPage);
    },
  },
};
</script>
